// Landing page test IDs
export const LANDING = {
  // Nav
  navWordmark: 'landing-nav-wordmark',
  navLinkFeatures: 'landing-nav-link-features',
  navLinkCommunity: 'landing-nav-link-community',
  navLinkAbout: 'landing-nav-link-about',
  navLoginBtn: 'landing-nav-login-btn',
  navJoinBtn: 'landing-nav-join-btn',
  navMobileMenuBtn: 'landing-nav-mobile-menu-btn',

  // Hero
  heroSection: 'landing-hero-section',
  heroHeadline: 'landing-hero-headline',
  heroSubheadline: 'landing-hero-subheadline',
  heroCtaPrimary: 'landing-hero-cta-primary',
  heroCtaSecondary: 'landing-hero-cta-secondary',

  // Marquee
  marqueeSection: 'landing-marquee-section',

  // Value props
  valuePropsSection: 'landing-value-props-section',
  valuePropCard: (key) => `landing-value-prop-${key}`,

  // Community showcase
  communitySection: 'landing-community-section',
  communityCard: (i) => `landing-community-card-${i}`,

  // Manifesto
  manifestoSection: 'landing-manifesto-section',
  manifestoChapter: (no) => `landing-manifesto-chapter-${no}`,

  // CTA
  ctaSection: 'landing-cta-section',
  ctaPrimaryBtn: 'landing-cta-primary-btn',
  ctaEmailInput: 'landing-cta-email-input',

  // Footer
  footer: 'landing-footer',
  footerWordmark: 'landing-footer-wordmark',
};
